"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("../utils/redux");
const constants_1 = require("../constants");
const get_1 = __importDefault(require("lodash/get"));
exports.initialState = {
    isConnected: false,
    name: null,
    shareUrl: null,
    pinCode: null,
    airPlayEnabled: false,
    isPresentationActive: false
};
/**
 * Stores 'hdmiPresentation' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- sharePresentation
 *       +-- isConnected: bool
 *       +-- name: string
 *       +-- shareUrl: string
 *       +-- pinCode: string
 *       +-- airPlayEnabled: bool
 *       +-- isPresentationActive: bool
 */
exports.default = redux_1.createReducer(exports.initialState, {
    [constants_1.app.actions.setSharePresentationInfo]: (state, action) => (Object.assign(Object.assign({}, state), { isConnected: get_1.default(action, 'payload.isConnected'), shareUrl: get_1.default(action, 'payload.shareUrl'), airPlayEnabled: get_1.default(action, 'payload.airPlayEnabled'), pinCode: get_1.default(action, 'payload.pinCode'), name: get_1.default(action, 'payload.name') })),
    [constants_1.app.actions.setSharePinCode]: (state, action) => (Object.assign(Object.assign({}, state), { pinCode: get_1.default(action, 'payload') })),
    [constants_1.app.actions.setSharePresentationActive]: (state, action) => (Object.assign(Object.assign({}, state), { isPresentationActive: get_1.default(action, 'payload') }))
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/reducers/sharePresentation.js
// module id = 608
// module chunks = 0